import { IRoad } from '../../types/geo';
import { MAX_SUGGESTIONS } from '../../interfaces/villages';
import { checkRegionInArray } from '../../utils';
import { ICommuteSuggest } from '../commute_popup';
import { Action } from './actions';

export interface IRoadSuggest extends IRoad, ICommuteSuggest {}

export interface IRoads {
  buttonStatus?: RoadsButtonStatus;
  currentRoads: IRoad[];
  isPopupOpened?: boolean;
  regionHasRoads: boolean;
  regions: number[];
  roadDistance: number;
  selectedRoads: number[];
  suggests?: IRoadSuggest[];
}

export function roadsReducer(state: IRoads, action: Action): IRoads {
  switch (action.type) {
    case 'FilterRegionChanged':
      return {
        ...state,
        regionHasRoads: checkRegionInArray(action.region, state.regions),
      };
    case 'RoadsFetched':
      return {
        ...state,
        currentRoads: action.roads,
      };
    case 'RoadsFiltered':
      return {
        ...state,
        suggests: action.roads.slice(0, MAX_SUGGESTIONS),
      };
    case 'RoadsPopupDistanceChanged':
      return {
        ...state,
        roadDistance: action.value,
      };
    case 'RoadsPopupSelectedRoadsChanged':
      return {
        ...state,
        selectedRoads: [...new Set(action.value)],
      };
    default:
      return state || { enabled: false, regions: [] };
  }
}

export enum RoadsButtonStatus {
  Enabled,
  Disabled,
  DisabledTooltip,
}
